import axios from '@src/utils/axios'

const axiosInstance = axios(false);

export default {
  SET_AUTH(state, payload){
    if(payload){
      localStorage.setItem('token', payload.token)
      axiosInstance.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    }else{
      localStorage.removeItem('token')
      delete axiosInstance.defaults.headers.common['Authorization']
    }

    //axiosInstance.defaults.headers.common['Authorization'] = localStorage.getItem('token')

    state.user = payload ? payload.user : {}
    state.token = payload ? payload.token : null
  },
  SET_MODULES(state, payload) {
    state.role_modules = payload ? payload.role_modules ? payload.role_modules.modules : null : null
  }
}